import { useLanguage } from "@/App";
import { translations } from "@/i18n";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ACCENTS = ["#D4AF37", "#3E7BD9", "#C8102E", "#D4AF37"];

const WhyNevada = () => {
  const { lang } = useLanguage();
  const t = translations[lang].why;

  return (
    <section id="why-nevada" data-testid="why-nevada-section" className="bg-[#0A1128] py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <div className="grid gap-8 md:grid-cols-12">
            <h2 className="font-display text-4xl font-black tracking-tighter text-white sm:text-5xl md:col-span-7">
              {t.title}
            </h2>
            <p className="self-end text-base font-light text-slate-300 md:col-span-4 md:col-start-9 md:text-lg">
              {t.sub}
            </p>
          </div>
        </Reveal>

        <div className="mt-24">
          {t.chapters.map((c, i) => (
            <Reveal key={`${lang}-${c.num}`} delay={i * 0.05}>
              <div
                data-testid={`nevada-chapter-${c.num}`}
                className="group grid items-start gap-6 border-t border-white/10 py-14 transition-colors duration-500 last:border-b hover:bg-white/[0.02] md:grid-cols-12 md:gap-10"
              >
                <span
                  className="font-display text-6xl font-black transition-opacity duration-500 group-hover:opacity-100 md:col-span-2 md:text-7xl"
                  style={{ color: ACCENTS[i], opacity: 0.45 }}
                >
                  {c.num}
                </span>
                <h3 className="font-display text-2xl font-semibold tracking-tight text-white md:col-span-4 md:text-3xl">
                  {c.title}
                </h3>
                <p className="text-base font-light leading-relaxed text-slate-300 md:col-span-5 md:col-start-8">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNevada;
